<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<idt-common-styles-render
  *ngIf="piece"
  [styles]="mergedStyles"
  [pressed]="active"
  [hover]="hover">
  <ng-container *idtLet="(orientation$ | async) as orientation">
    <render-link
      [analyticsEventName]="analyticsEventClickButton"
      [analyticsEventData]="analyticsEventData"
      [lang]="lang"
      [link]="settings.general.link"
      [piece]="piece"
      (renderLinkEvent)="onRenderLinkClick($event)">
      <ng-container *ngTemplateOutlet="bgImg;"></ng-container>
    </render-link>

    <ng-template #bgImg>
      <div
        tabindex="0"
        role="button"
        [attr.class]="'button-holder text-' + settings.general.buttonStyles.imageToTextPosition"
        (mouseenter)="buttonHolderMouseIn()"
        (mouseleave)="buttonHolderMouseOut()"
        (mousedown)="buttonHolderMouseDown()"
        [ngStyle]="settingsStyleButtonHolder()">
        <div
          *ngIf="settings.general.landscapeImage?.image || settings.general.portraitImage?.image"
          #image
          class="image">
          <ng-container *ngTemplateOutlet="imageSelector"></ng-container>
        </div>
        <div
          *ngIf="this.piece.settings && this.piece.settings.general.text"
          class="wysiwyg"
          [ngStyle]="settingsStyleWysiwyg()">
          <render-wysiwyg
            [html]="settings.general.text"
            [lang]="lang"
            [country]="country"
            [piece]="piece"
            [textPaddingTop]="settings.general.textPaddingTop"
            [textPaddingBottom]="settings.general.textPaddingBottom"
            [textPaddingLeft]="settings.general.textPaddingLeft"
            [textPaddingRight]="settings.general.textPaddingRight">
          </render-wysiwyg>
        </div>
      </div>
    </ng-template>

    <ng-template #imageSelector>
      <img
        *ngIf="orientation === 'landscape' && settings.general.landscapeImage?.image"
        src="{{ getLandscapeImageSrc() }}"
        [attr.alt]="settings.general.alt"
        alt=""
        [attr.title]="settings.general.title" />

      <img
        *ngIf="orientation === 'portrait' && settings.general.portraitImage?.image"
        src="{{ getPortraitImageSrc() }}"
        [attr.alt]="settings.general.alt"
        alt=""
        [attr.title]="settings.general.title">
    </ng-template>
  </ng-container>
</idt-common-styles-render>

